// @theme component
import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector, useDeviceSelector } from '@core/js/store/hooks';
import { showSmsVerificationPopupAction } from '@theme/js/components/system/App/store/actions';
import { STEPS_NAME, VERIFICATION_TYPES } from '@theme/js/components/main/SmsVerification/constants';
import { useDispatch } from 'react-redux';

export const useShowSmsVerification = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return useCallback(async ({
        type = VERIFICATION_TYPES.DEFAULT,
        showDrawer = false }: {
            type?: string,
            showDrawer?: boolean
        } = {}) => {

        if (isLoggedIn) {
            dispatch(showSmsVerificationPopupAction(
                {
                    verificationType: type, step: showDrawer ?
                        !isDesktop ? STEPS_NAME.DRAWER : STEPS_NAME.INITIAL : STEPS_NAME.INITIAL
                }
            ));
        }
    }, [dispatch, isDesktop, isLoggedIn]);
};
